module.exports = __webpack_public_path__ + "img/sm.4e0bd00d.svg";